import { ThunkType } from "../../../../core/store/reducers";
import getEtfCompositionApi from "../api/getEtfComposition";
import { setDisplayedEtfComposition } from "../statisticsDataSlice";
import { EtfCompositionItem } from "../types";

// Load funkcija (reset + fetch)
export const loadEtfComnposition = (
	symbol: string
): ThunkType => async (dispatch, getStore) => {
	// reset prethodnih podataka
	dispatch(setDisplayedEtfComposition(undefined));

	const etfcomposition = await dispatch(
		getEtf_Composition(symbol)
	);
	console.log(etfcomposition)

	dispatch(setDisplayedEtfComposition(etfcomposition));
};

export const getEtf_Composition = (
	symbol: string
): ThunkType<Promise<EtfCompositionItem | undefined>> =>
	async (dispatch, getStore, _extra) => {

		const store = getStore();

		if (store.data.auth.current.status !== "successful") {
			return undefined;
		}
		const { userId } = store.data.auth.current.user;

		const response = await dispatch(
			getEtfCompositionApi(userId, symbol, "etfs/world/composition")
		);


		console.log(response)
		if (!response || !response.etf) {
			return undefined;
		}

		const { etf } = response;

		return {
			symbol: symbol,
			major_market_sectors:
				etf.composition.major_market_sectors
					?.map(s => `${s.sector} (${s.weight}%)`)
					.join("\n") ?? "",
			countryAllocation: etf.composition.country_allocation,
			assetAllocationCash: etf.composition.asset_allocation.cash,
			assetAllocationStocks: etf.composition.asset_allocation.stocks,
			assetAllocationPreferred: etf.composition.asset_allocation.preferred_stocks,
			assetAllocationConvertables: etf.composition.asset_allocation.convertables,
			assetAllocationBonds: etf.composition.asset_allocation.bonds,
			assetAllocationOthers: etf.composition.asset_allocation.others,
			topHolding: etf.composition.top_holdings[0]
				? `${etf.composition.top_holdings[0].symbol} (${etf.composition.top_holdings[0].name}) - ${etf.composition.top_holdings[0].weight}%`
				: "",
			bondAverageMaturityFund:
				etf.composition.bond_breakdown.average_maturity?.fund ?? "",
			bondAverageDurationFund:
				etf.composition.bond_breakdown.average_duration?.fund ?? "",
			bondCreditQuality:
				etf.composition.bond_breakdown.credit_quality
					?.map(q => {
						if (!q.grade) return null;

						return `${q.grade} (${q.weight ?? 0})`;
					})
					.filter(Boolean)
					.join("\n") ?? "",
		};
	};